import { Action, State as CaseState } from 'modules/cm/store/cases/types';
import { Dispatch } from 'redux';
import { RootState } from 'store/configureStore';
import dotProp from 'dot-prop';
import * as sharedActions from 'modules/cm/store/sharedActions';
import { CaseError } from 'modules/cm/domain/Case/Error';

const removeErrorForCaseErrors = (fieldPaths: string[]) => (caseError: CaseError) => {
  const newCaseErrors = JSON.parse(JSON.stringify(caseError));
  fieldPaths.forEach((fieldPath) => {
    dotProp.set(newCaseErrors, fieldPath, null);
  });

  return newCaseErrors;
};

const clearCaseError = (fieldPaths: string[]) => {
  return (dispatch: Dispatch<Action>, getState: () => RootState) => {
    const removeFieldsError = removeErrorForCaseErrors(fieldPaths);

    const { caseErrors: caseError } = getState().currentCase as NonNullable<CaseState>;
    const { error: pepperError } = getState().casePepperError;

    if (caseError) {
      const newCaseErrors = removeFieldsError(caseError);
      sharedActions.setCaseErrors(newCaseErrors)(dispatch);
    }

    if (pepperError) {
      const newCaseErrors = removeFieldsError(pepperError);
      sharedActions.setCasePepperError(newCaseErrors)(dispatch as Dispatch);
    }
  };
};

export default clearCaseError;
